import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'
import { CellValueChangedEvent } from 'ag-grid-enterprise'

import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { Widget, WidgetContent, WidgetHeaderWithQuery, useApi } from '@fortem-monorepo/react-spa'
import { useUserContext } from '@fortem-monorepo/react-spa'
import { Smartrade } from '@fortem-monorepo/web-sdk'

import { tagsColDef } from '@/ag-grid/columns/tag-column/col-def'
import { Page } from '@/components/Page'
import { SMARTRADE } from '@/constants/links'
import { useUpdateClientEmaildistMutation } from '@/react-query/mutations/smartrade'

export interface SmartradeClientsPageProps {}

export const SmartradeClientsPage: React.FC<SmartradeClientsPageProps> = ({}) => {
  const api = useApi()

  const query = useQuery({
    queryKey: ['smartrade', 'clients'],
    queryFn: async () => api.smartrade.getClients(),
  })

  const updateClientEmaildistMutation = useUpdateClientEmaildistMutation()

  const { hasPermissions } = useUserContext()
  const canEdit = hasPermissions((permissions) => ({
    permissions: [permissions.WRITE_SMARTRADE_DATA],
  }))

  const colDefs = useMemo(() => makeColDefs({ canEdit }), [])

  return (
    <Page metadata={{ title: 'Clients - Smartrade' }} permissions={SMARTRADE.CLIENTS.permissions}>
      <Widget className={'h-full'} exposed>
        <WidgetHeaderWithQuery title="Smartrade Client Lists" query={query} />
        <WidgetContent loading={query.isLoading}>
          <CustomAgGrid
            getRowId={(params: any) => params.data.firmid.toString()}
            rowData={query.data ?? []}
            query={query}
            columnDefs={colDefs}
            onCellValueChanged={(
              params: CellValueChangedEvent<Smartrade.GetSmartradeClientsData[number]>,
            ) => {
              return updateClientEmaildistMutation.mutateAsync({
                oldValue: params.oldValue,
                newValue: params.newValue,
                data: params.data,
                updatedField: params.colDef.field,
              })
            }}
          />
        </WidgetContent>
      </Widget>
    </Page>
  )
}

const makeColDefs = ({ canEdit }: { canEdit: boolean }) => {
  return createColDefs<Smartrade.GetSmartradeClientsData[number]>([
    {
      field: 'firmid',
      headerName: 'Firm ID',
    },
    {
      field: 'firm',
      headerName: 'Firm',
      width: 300,
    },
    tagsColDef<Smartrade.GetSmartradeClientsData[number]>({
      field: 'emaildist',
      editable: canEdit,
      width: 1000,
    }),
    // {
    //   field: 'emaildist',
    //   headerName: 'Recipients',
    //   width: 500,
    //   editable: canEdit,
    // },
  ])
}
